import { Theme } from "@mui/material";

export const inputLabelStyles = (theme: Theme) => ({ sx: { color: theme.palette.text.primary } });
